import cn from 'classnames';
import parse from 'html-react-parser';
import { FC } from 'react';

import { cleanBuilderStringInput, getBuilderString } from '@/shared/text';

import style from './Card.module.scss';

export enum LinkType {
  INTERNAL = 'in the page',
  EXTERNAL = 'external',
}

export interface LinkInput {
  color: string;
  link: string;
  linkType: LinkType;
  title: string;
  subTitle: string;
  imageUrl: string;
}

export interface Props extends LinkInput {
  locale: string;
}

export const Card: FC<Props> = ({
  locale,
  link,
  linkType,
  title,
  subTitle,
  imageUrl,
}) => {
  const linkUrl = getBuilderString(link, locale);
  const href = linkType === LinkType.EXTERNAL ? linkUrl : `#${linkUrl}`;
  const target = linkType === LinkType.EXTERNAL ? '_blank' : '_self';

  return (
    <a
      href={href}
      className={cn(style.card, 'u-bgcolor-secondary')}
      target={target}
      rel="noreferrer"
    >
      <div className={cn(style.content, 'u-p-m', 'u-p-sm-xs')}>
        <header className={cn(style.header)}>
          {parse(cleanBuilderStringInput(getBuilderString(title, locale)))}
        </header>
        <p
          className={cn(
            style.subtitle,
            'u-typography-body-s',
            'u-color-secondary'
          )}
        >
          {parse(cleanBuilderStringInput(getBuilderString(subTitle, locale)))}
        </p>
      </div>
      {getBuilderString(imageUrl, locale) && (
        <img
          alt={''}
          className={style.image}
          src={cleanBuilderStringInput(
            getBuilderString(imageUrl, locale),
            true
          )}
        />
      )}
    </a>
  );
};
